import React from 'react';
import { Link } from 'react-router-dom';
import { linkClass } from '../utils/linkClass';
type SiteHeaderProps = {
  /** Render as the page header (default) or as the repeated site footer. */
  as?: 'header' | 'footer';
};
export function SiteHeader({
  as = 'header'
}: SiteHeaderProps) {
  const Tag = as;
  const isFooter = as === 'footer';
  return <Tag className={`flex flex-col gap-3 md:flex-row md:items-center md:justify-between ${isFooter ? 'border-t border-black/10 pt-8' : ''}`} data-id="element-93" data-mp="1ipwhm8kjtae0">
      <Link to="/" className="flex w-fit items-center gap-x-2 rounded text-[clamp(13px,4vw,16px)] leading-6 min-[700px]:gap-x-[14px] min-[700px]:text-base focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-link" data-id="element-94" data-mp="qxys4z1tqb6w">
        <span className="whitespace-nowrap font-bold" data-id="element-95" data-mp="2gait7xa6rrum">MICHAEL MEIKSON</span>
        <span className="whitespace-nowrap text-muted" data-id="element-96" data-mp="2bd0h5y0vgwie">Senior Product Designer</span>
      </Link>
      <nav className="flex items-center gap-8 text-xs" aria-label={isFooter ? 'Footer contact' : 'Contact'} data-id="element-97" data-mp="29k29qel7pjtx">
        <a href="https://cdn.magicpatterns.com/uploads/pwegPEgunv1kfUYB7UCBEg/Michael_Meikson_Resume.pdf" download="Michael_Meikson_Resume.pdf" target="_blank" rel="noopener noreferrer" className={`whitespace-nowrap ${linkClass}`} data-id="element-98" data-mp="2eidj6o7lhsbm">
          Download Resume
        </a>
        <a href="mailto:mike@meikson.com" className={`whitespace-nowrap ${linkClass}`} data-id="element-99" data-mp="1qunfb3017syi">
          mike@meikson.com
        </a>
      </nav>
    </Tag>;
}